import React from 'react';
import { number, func } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { EventTypes } from '../../../../../../../../../../shared/utils/events/types';
import eventsReporter from '../../../../../../../../../../shared/utils/events/reporter';

import './style.scss';

const { sellerCard } = EventTypes.collectionPage;

const AvailableServicesTrigger = ({ total, onClick = Function.prototype }) => {
    const handleClick = () => {
        eventsReporter.report(sellerCard.availableServices.clicked);

        onClick();
    };

    const wrapperClasses = classNames('available-services-trigger', 'tbody-6');

    return (
        <button className={wrapperClasses} onClick={handleClick}>
            <I18n k="collections_perseus.collection_page.seller_card.available_services" params={{ total }} />
        </button>
    );
};

AvailableServicesTrigger.propTypes = {
    total: number,
    onClick: func,
};

export default AvailableServicesTrigger;
